module.exports = __webpack_public_path__ + "static/media/UberMoveMedium.55170d1c.otf";